export function toNativeDate(value: unknown): Date | null {
  if (!value || typeof value === 'string') {
    return null;
  }

  if (value instanceof Date) {
    return value;
  }

  if (
    typeof value === 'object' &&
    'year' in value &&
    'month' in value &&
    'date' in value &&
    typeof value.year === 'function' &&
    typeof value.month === 'function' &&
    typeof value.date === 'function'
  ) {
    return new Date(value.year(), value.month(), value.date());
  }

  return null;
}

export function toUtcDate(value: unknown): Date | null {
  const nativeDate = toNativeDate(value);

  if (!nativeDate || Number.isNaN(nativeDate.getTime())) {
    return null;
  }

  return new Date(Date.UTC(nativeDate.getFullYear(), nativeDate.getMonth(), nativeDate.getDate(), 0, 0));
}
